/**
 * Admin document analysis job models.
 * Match the /api/admin/document-jobs responses.
 */

export enum DocumentJobStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum DocumentJobType {
  SINGLE = 'single',
  BATCH = 'batch',
}

export interface DocumentJobUser {
  id: string;
  firstName: string;
  lastName: string;
}

export interface DocumentJobCompany {
  id: string;
  name: string;
}

export interface DocumentJobTrip {
  id: string;
  title: string;
  status: string;
}

export interface AdminDocumentJob {
  id: string;
  batchId: string;
  userId: string;
  companyId: string;
  originalFileName: string;
  s3Key: string;
  status: DocumentJobStatus;
  tripId: string | null;
  errorMessage: string | null;
  metadata: unknown | null;
  createdAt: string;
  processedAt: string | null;
  user: DocumentJobUser;
  company: DocumentJobCompany;
  trip: DocumentJobTrip | null;
}

export interface AdminDocumentJobDetail extends AdminDocumentJob {
  brochureUrl: string | null;
}

/** Shape written by ProcessDocumentJob on IA failure. */
export interface DocumentJobErrorMetadata {
  errorCode?: string;
  errorContext?: {
    method?: string;
    reason?: string;
    finishReason?: string;
    generatedTextLength?: number;
    usage?: { promptTokens?: number; completionTokens?: number };
    responseId?: string;
    responseModel?: string;
    responseTimestamp?: string;
    [key: string]: unknown;
  };
  failedAt?: string;
}

/** Shape written by AiExtractionService on success. */
export interface DocumentJobSuccessMetadata {
  confidenceScore?: number;
  warnings?: string[];
  extractionMethod?: string;
  [key: string]: unknown;
}

export interface DocumentJobFilters {
  status?: DocumentJobStatus | null;
  type?: DocumentJobType | null;
  companyId?: string | null;
}

export interface PaginationParams {
  page: number;
  limit: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}
